import { getNotFoundErrorEndpoint, HeroTeaserDto } from 'cpes-common';
import { createCmsContentSlice } from 'cms-integration';

const { reducer, fetchContent } = createCmsContentSlice<HeroTeaserDto>({
    contentName: 'notFoundErrorContent',
    contentEndpoint: getNotFoundErrorEndpoint,
});

export default reducer;
export const fetchNotFoundError = fetchContent;
